enum Mutations {
  setFeaturedUsers = 'setFeaturedUsers',
  setUsers = 'setUsers',
  setRankedUsers = 'setRankedUsers',
  setUserLoading = 'setUserLoading',
  setRankedUsersLastPage = 'setRankedUsersLastPage',
}

export default Mutations;
